module.exports = __webpack_public_path__ + "static/media/codePieChart.31e03f69.gif";